import apiClient from "@/shared/api/apiClient2";

export const getTariffList = async (params) => {
  try {
    const { data } = await apiClient.get("/tariffs/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getTariffList failed", e);
  }
};

export const getTariffItem = async (id) => {
  try {
    const { data } = await apiClient.get(`/tariffs/${id}/`);
    return data;
  } catch (e) {
    console.error("getTariffItem failed", e);
  }
};

export const createTariff = async (params) => {
  const result = await apiClient.post(`/tariffs`, {
    ...params,
  });
  return result.data;
};

export const updateTariff = async (id, params) => {
  const { data } = await apiClient.patch(`/tariffs/${id}`, {
    ...params,
  });
  return data;
};

export const removeTariff = async (id) => {
  const { data } = await apiClient.delete(`/tariffs/${id}`);
  return data;
};

export const getTariffPreferentialList = async (params) => {
  try {
    const { data } = await apiClient.get("/tariffs/preferential/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getTariffPreferentialList failed", e);
  }
};

export const getTariffPreferentialItem = async (id) => {
  try {
    const { data } = await apiClient.get(`/tariffs/preferential/${id}/`);
    return data;
  } catch (e) {
    console.error("getTariffPreferentialItem failed", e);
  }
};

export const createPreferentialTariff = async (params) => {
  const result = await apiClient.post(`/tariffs/preferential/`, {
    ...params,
  });
  return result.data;
};

export const updatePreferentialTariff = async (id, params) => {
  const { data } = await apiClient.patch(`/tariffs/preferential/${id}`, {
    ...params,
  });
  return data;
};

export const removeTariffPreferential = async (id) => {
  const { data } = await apiClient.delete(`/tariffs/preferential/${id}`);
  return data;
};
//

export const getMrpList = async (params) => {
  try {
    const { data } = await apiClient.get("/mrp/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getMrpList failed", e);
  }
};

export const getMrpItem = async (id) => {
  try {
    const { data } = await apiClient.get(`/mrp/${id}/`);
    return data;
  } catch (e) {
    console.error("getMrpItem failed", e);
  }
};

export const createMrp = async (params) => {
  const result = await apiClient.post(`/mrp/`, {
    ...params,
  });
  return result.data;
};

export const updateMrp = async (id, params) => {
  const { data } = await apiClient.patch(`/mrp/${id}`, {
    ...params,
  });
  return data;
};

export const removeMrp = async (id) => {
  const { data } = await apiClient.delete(`/mrp/${id}`);
  return data;
};
